import Stack from '@/design_system/Stack';
import Paragraph from '@/design_system/Typography/Paragraph';

interface EmptyStateProps {
  title?: React.ReactNode;
  subtitle: React.ReactNode;
  illustration?: React.ReactNode;
}

/**
 *
 * Display some text, optionally with an illustration, when there is no data to display
 */
export const EmptyState = ({ title, subtitle, illustration }: EmptyStateProps) => {
  // Without an illustration, the text reads like an empty table row: left-aligned
  const alignItems = illustration ? 'center' : 'flex-start';
  const align = illustration ? 'center' : 'left';

  return (
    <Stack gap="16px" alignItems={alignItems} justifyContent="center" style={{ flex: 1 }}>
      {illustration}

      <Stack gap="4px" alignItems={alignItems}>
        {title && (
          <Paragraph size="50" weight="medium" align={align}>
            {title}
          </Paragraph>
        )}

        <Paragraph size="100" align={align}>
          {subtitle}
        </Paragraph>
      </Stack>
    </Stack>
  );
};
